import { useState } from 'react';

import { TabsTruot } from '../../../components/shared';
import { useT } from '../../../i18n';
import { soVN } from '../../../lib/dinh-dang';
import { useSuDung } from '../hooks/useCanhBao';
import { phanTramDaDung } from '../nghiep-vu/canh-bao';
import type { PhamViCanhBao } from '../types';
import { CauHinhKenh } from './CauHinhKenh';
import { DanhMucNenTang } from './DanhMucNenTang';
import { DanhSachTacVu } from './DanhSachTacVu';
import { GiamSatGui } from './GiamSatGui';
import { NhatKyCanhBao } from './NhatKyCanhBao';

type The = 'tac-vu' | 'kenh' | 'nhat-ky' | 'danh-muc' | 'giam-sat';

/** Phần trăm hạn mức mà từ đó dòng số liệu đổi tông cảnh báo. */
const NGUONG_GAN_HET = 80;

/**
 * Ba tab như aaPanel (Danh sách cảnh báo, Cấu hình kênh, Nhật ký cảnh báo), dùng chung cho hai cổng: cùng API
 * `/api/v1/notify/*`, server phân phạm vi theo token. Cổng nền tảng thêm "Danh mục" và "Giám sát gửi".
 *
 * Chuyển thẻ từ bên trong (bấm "Xem lịch sử", "Mở Cấu hình kênh") dựng lại `TabsTruot` với thẻ mở sẵn mới.
 */
export function TrungTamCanhBao({ pv, duocSua }: { pv: PhamViCanhBao; duocSua: boolean }) {
  const { t, locale } = useT();
  const [the, setThe] = useState<The>('tac-vu');
  const [lanChuyen, setLanChuyen] = useState(0);
  const [taskId, setTaskId] = useState<string | undefined>();
  const suDung = useSuDung(pv === 'tenant');

  const chuyen = (moi: The) => {
    setThe(moi);
    setLanChuyen((n) => n + 1);
  };

  const items = [
    {
      key: 'tac-vu',
      label: t('canhBao.tabTacVu'),
      children: (
        <DanhSachTacVu
          pv={pv}
          duocSua={duocSua}
          onXemLichSu={(id) => {
            setTaskId(id);
            chuyen('nhat-ky');
          }}
          onMoCauHinhKenh={() => chuyen('kenh')}
        />
      ),
    },
    {
      key: 'kenh',
      label: t('canhBao.tabKenh'),
      children: <CauHinhKenh pv={pv} duocSua={duocSua} />,
    },
    {
      key: 'nhat-ky',
      label: t('canhBao.tabNhatKy'),
      children: <NhatKyCanhBao pv={pv} taskId={taskId} onDoiTask={setTaskId} duocSua={duocSua} />,
    },
    ...(pv === 'nen-tang'
      ? [
          {
            key: 'danh-muc',
            label: t('canhBao.tabDanhMuc'),
            children: <DanhMucNenTang />,
          },
          {
            key: 'giam-sat',
            label: t('canhBao.tabGiamSat'),
            children: <GiamSatGui />,
          },
        ]
      : []),
  ];

  const u = suDung.data;
  const phanTram = u ? phanTramDaDung(u) : null;

  return (
    <div className="space-y-3">
      {u && (
        <p
          className={
            phanTram !== null && phanTram >= NGUONG_GAN_HET ? 'text-xs text-warning-700' : 'text-xs text-content-muted'
          }
          role="status"
        >
          {u.limit != null
            ? t('canhBao.suDung', {
                so: soVN(u.sent, locale),
                toiDa: soVN(u.limit, locale),
              })
            : t('canhBao.suDungKhongGioiHan', { so: soVN(u.sent, locale) })}
          {phanTram !== null && phanTram >= NGUONG_GAN_HET && ` ${t('canhBao.suDungGanHet', { phanTram })}`}
        </p>
      )}
      <TabsTruot key={lanChuyen} defaultActiveKey={the} onChange={(k) => setThe(k as The)} items={items} />
    </div>
  );
}
